import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export function InsuredProfileShortcut() {
  const navigate = useNavigate();
  useEffect(() => {
    const openProfile = (event) => {
      const row = event.target.closest('[data-testid^="insured-row-"]');
      if (!row || event.target.closest('button, input, a')) return;
      const id = row.dataset.testid.replace("insured-row-", "");
      navigate(`/insureds/${id}`);
    };
    document.addEventListener("dblclick", openProfile);
    return () => document.removeEventListener("dblclick", openProfile);
  }, [navigate]);
  return null;
}